import { rgba } from 'polished';
import styled, { css } from 'styled-components';
import { ifProp, palette } from 'styled-tools';

import { Close as close } from '@calm-web/icons';

import { units } from '../../utils/spacing';
import { fontSize, FontSizes, lineHeight } from '../../utils/typography';
import { ButtonIcon } from '../Button/styles';
import IconButton from '../IconButton';
import { PaletteColor } from '../ThemeProvider';

export const Wrapper = styled.div<{
	$backgroundColor: PaletteColor;
	$textColor: PaletteColor;
	$addMargins?: boolean;
	$fullPageWidth?: boolean;
	$textAlign: React.CSSProperties['textAlign'];
	$fontWeight: React.CSSProperties['fontWeight'];
}>`
	padding: ${units(1, 1.5)};
	display: flex;
	gap: ${units(1)};
	align-items: center;
	background: ${props => palette(props.$backgroundColor)};
	color: ${props => palette(props.$textColor)};
	${fontSize(FontSizes.sm)};
	${lineHeight(FontSizes.sm)};
	text-align: ${props => props.$textAlign};
	font-weight: ${props => props.$fontWeight};
	${props => {
		if (!props.$fullPageWidth) {
			return css`
				border-radius: 4px;
				box-shadow: ${units(0, 1, 2)} ${rgba(palette('black')(props), 0.15)};
			`;
		}
	}}
	${ifProp(
		'$addMargins',
		css`
			margin: ${units(1)};
		`,
	)};

	> svg {
		width: ${units(2)};
		height: ${units(2)};
		path {
			fill: ${props => palette(props.$textColor)};
		}
	}
`;

export const ChildrenWrapper = styled.div`
	flex-grow: 1;
	width: 100%;
`;

export const CloseButton = styled(IconButton).attrs({
	Icon: close,
	'aria-label': 'close',
})`
	min-height: 0;
	min-width: 0;
	padding: ${units(1, 1.5)};
	margin: ${units(-1, -1.5)};
	height: 100%;

	${ButtonIcon} {
		display: flex;
		height: 1rem;
		width: 1rem;

		& svg {
			height: 1rem;
			width: 1rem;
		}
	}
`;
